import { inject, injectable } from "inversify";
import { Logger, type PointerPosition } from "@designboticteam/core";
import type { ITool } from "../../../../tooling/ITool";
import { ShapeEditingService } from "../../../services/ShapeEditingService";

/**
 * The generic "select and edit any shape" tool: every pointer event goes straight to
 * ShapeEditingService. Tools with their own editing mode (ZoneTool) forward to the service
 * themselves and never activate this one.
 */
@injectable()
class SelectTool implements ITool {
	public static readonly toolName: string = "SelectTool";
	public readonly toolName: string = SelectTool.toolName;
	private readonly logger = new Logger(`🖱️ ${this.toolName}`, { color: "#ffffff", backgroundColor: "#0f766e" });

	constructor(@inject(ShapeEditingService) private readonly shapeEditingService: ShapeEditingService) {
		this.logger.log("constructed");
	}

	public onActivate(): void {
		this.shapeEditingService.reset();
		this.logger.log("activated");
	}

	public onDeactivate(): void {
		this.shapeEditingService.reset();
		this.logger.log("deactivated");
	}

	public onTap(position: PointerPosition): void {
		this.shapeEditingService.onTap(position);
	}

	public onPointerMove(position: PointerPosition): void {
		this.shapeEditingService.onPointerMove(position);
	}

	public onPointerDown(position: PointerPosition): void {
		this.shapeEditingService.onPointerDown(position);
	}

	public onDragStart(position: PointerPosition): void {
		this.shapeEditingService.onDragStart(position);
	}

	public onDragMove(position: PointerPosition): void {
		this.shapeEditingService.onDragMove(position);
	}

	public onDragEnd(position: PointerPosition): void {
		this.shapeEditingService.onDragEnd(position);
	}
}

export { SelectTool };
